/**
 * Audit Logs Service
 * API calls for audit log management (admin only)
 */

import apiClient from '../lib/axios';
import type { AuditLog, AuditLogActor } from '../types';

export interface AuditLogsQueryParams {
  page?: number;
  limit?: number;
  sort?: string;
  time_range?: 'today' | '7days' | '30days' | 'all';
  actor_id?: number;
  event_type?: string;
  result?: 'success' | 'failure';
  export?: boolean;
}

export interface PaginatedAuditLogsResponse {
  success: boolean;
  data: AuditLog[];
  meta: {
    page: number;
    limit: number;
    total: number;
    total_pages: number;
  };
  actors: AuditLogActor[];
}

export const auditLogsService = {
  /**
   * Get paginated audit logs with filters (admin only)
   */
  getPaginated: async (params: AuditLogsQueryParams = {}): Promise<PaginatedAuditLogsResponse> => {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.set('page', String(params.page));
    if (params.limit) queryParams.set('limit', String(params.limit));
    if (params.sort) queryParams.set('sort', params.sort);
    if (params.time_range) queryParams.set('time_range', params.time_range);
    if (params.actor_id) queryParams.set('actor_id', String(params.actor_id));
    if (params.event_type) queryParams.set('event_type', params.event_type);
    if (params.result) queryParams.set('result', params.result);
    if (params.export) queryParams.set('export', 'true');

    const queryString = queryParams.toString();
    const url = queryString ? `/audit_logs?${queryString}` : '/audit_logs';

    const { data } = await apiClient.get<PaginatedAuditLogsResponse>(url);
    return data;
  },

  /**
   * Get all audit logs matching filters for CSV export
   */
  getForExport: async (params: AuditLogsQueryParams = {}): Promise<AuditLog[]> => {
    const response = await auditLogsService.getPaginated({ ...params, export: true });
    return response.data;
  },
};
